import { render, staticRenderFns } from "./LessonData.vue?vue&type=template&id=5ea8cffe&scoped=true&"
import script from "./LessonData.vue?vue&type=script&lang=js&"
export * from "./LessonData.vue?vue&type=script&lang=js&"
import style0 from "./LessonData.vue?vue&type=style&index=0&id=5ea8cffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8cffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
